import { Box, Button, Code, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";

export function ItemCategoryForm(params: {
  name: string;
  onSubmit?: (values: any) => void;
}) {
  const { name, onSubmit } = params;
  const form = useForm({
    initialValues: {
      name: name, // 품목군 코드
    },
  });

  return (
    <Box maw={320} mx="auto">
      <form onSubmit={form.onSubmit((values) => onSubmit && onSubmit(values))}>
        <TextInput
          label="품목분류"
          placeholder="name"
          defaultValue={name}
          {...form.getInputProps("name")}
        />
        <Text size="sm" weight={500} mt="xl">
          Form values:
        </Text>
        <Code block mt={5}>
          {JSON.stringify(form.values, null, 2)}
        </Code>
        <Button type="submit">Submit</Button>
      </form>
    </Box>
  );
}
